import React from 'react';
import {Row, Col, UncontrolledCollapse, CardBody} from 'reactstrap';
import {Table} from 'reactstrap';


export default function  TestCaseList(props)
{
	var testCases = null;
	var testsTable = null;

	if(!props.graderOutput.hasMessage)
	{

		testCases = props.graderOutput.wrongTestCases.map((el)=>
			{
				return <TestCase key={el.caseIndex} testCase={el}/>
			});
        if(props.graderOutput.submissionDetails.state === "finished")
            testsTable = props.graderOutput.submissionDetails.testResults.map( (el, idx) => {
            	var color =  el.output ? '' : 'maroon';
                return <tr style={{backgroundColor:color}}>
                    <td> TEST_{idx} </td>
                    <td> {el.output ? "DA" : props.graderOutput.wrongTestCases.find(function(el){return el.caseIndex === idx}).message} </td>
                    <td> {el.time} ms</td>
                    <td> {el.wall_time} ms</td>
                    <td> {el.memory/1024/1024} MB </td>
                </tr>;
            });
        else
            testsTable = (<tr> <td colSpan={5}> {props.graderOutput.submissionDetails.state} </td></tr>)
	}

	return (
		<React.Fragment>
			{
				props.graderOutput.hasMessage ?
				(
					<Row>
						<Col>
							<pre>
								{props.graderOutput.message}
							</pre>
						</Col>
					</Row>
				)
				:
				(
					<Row>
                        <Table size="sm" bordered>
                            <thead>
                            <tr>
                                <th> #</th>
                                <th> isCorrect</th>
                                <th> time</th>
                                <th> wall time</th>
                                <th> memory</th>
                            </tr>
                            </thead>
                            <tbody>
                            {testsTable}
                            </tbody>
                        </Table>

						<Table>
							<thead>
								<th> # </th>
								<th> Poruka </th>
								<th> Status </th>
							</thead>
							<tbody>
							{testCases}
							</tbody>
						</Table>
					</Row>
				)
			}
		</React.Fragment>
	);
}

//==========================================Helper Component=======================================
function TestCase(props)
{
	const inputFiles = props.testCase.data.input_files.map((el)=>
		{
			return (

				<tr>
					<th scope='row' style={{textAlign:'center'}}>Ulazni fajl: {el.filename} </th>
					<td align='center'><pre>{el.content}</pre></td>
				</tr>
			);
		});

	const outputFiles = props.testCase.data.output_files.map((el)=>
		{
			return (

				<tr>
					<th scope='row' style={{textAlign:'center'}}>Izlazni fajl: {el.filename} </th>
					<td align='center'><pre>{el.content}</pre></td>
				</tr>
			);
		});

	return (
		<React.Fragment>
			<tr id={'toggleCard' + props.testCase.caseIndex}
						style={{cursor:'pointer'}}>
					<td>
						#{props.testCase.caseIndex}
					</td>
					<td>
                        {props.testCase.message}
					</td>
					<td>
						<span style = {{ color: (props.testCase.correct ? 'green' : 'red')}}>
							{props.testCase.correct ? 'OK!' : 'Failed!'}
						</span>
					</td>
			</tr>
			<tr>
				<td colSpan="3">
					<UncontrolledCollapse toggler={'#toggleCard' + props.testCase.caseIndex}>
						<CardBody>
							<Table bordered striped>
								<tbody>
									<tr>
										<th scope='row' style={{textAlign:'center'}}>Pokretanje</th>
										<td align='center'>./a.out {props.testCase.data.args}</td>
									</tr>

									<tr>
										<th scope='row' style={{textAlign:'center'}}>Ulaz</th>
										<td align='center'>{props.testCase.data.input}</td>
									</tr>

									{
										props.testCase.data.input_files.length !== 0 &&
										inputFiles
									}

									<tr>
										<th scope='row' style={{textAlign:'center'}}>Izlaz</th>
										<td align='center'>{props.testCase.data.output}</td>
									</tr>

									{
										props.testCase.data.output_files.length !== 0 &&
										outputFiles
									}

									<tr>
										<th scope='row' style={{textAlign:'center'}}>Izlaz za greske</th>
										<td align='center'>{props.testCase.data.error}</td>
									</tr>
								</tbody>
							</Table>
						</CardBody>
					</UncontrolledCollapse>
				</td>
            </tr>
		</React.Fragment>
	);
}
